import { render } from "./VerifyCodePage.vue?vue&type=template&id=2e1f0fb0&scoped=true"
import script from "./VerifyCodePage.vue?vue&type=script&lang=js"
export * from "./VerifyCodePage.vue?vue&type=script&lang=js"

import "./VerifyCodePage.vue?vue&type=style&index=0&id=2e1f0fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1f0fb0"]])

export default __exports__